import type { Nutrients } from '@/utils/nutrients'

export const hiddenNutrients: Nutrients[] = [
  'energy_value_according_regulation_kcal',
  'energy_value_according_regulation_kj',
  'protein_according_regulation',
]
